<div class="sw-cms-el-preview-moorl-product-buy-list">
    <p>{{ $tc(label) }}</p>
    <hr/>
    <div class="sw-cms-el-preview-moorl-product-buy-list-grid">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
    </div>
</div>